import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as l}from"../../icon-registry.js";const p=l("ethiopia",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#DA121A" />
            <path
                d="M0 4.5H24V15.1667H0V4.5Z"
                fill="#FCDD09" />
            <path
                d="M0 4.5H24V9.83333H0V4.5Z"
                fill="#078930" />
            <path
                d="M12 17.8327C14.6579 17.8327 16.8125 15.4449 16.8125 12.4993C16.8125 9.55383 14.6579 7.16602 12 7.16602C9.34213 7.16602 7.1875 9.55383 7.1875 12.4993C7.1875 15.4449 9.34213 17.8327 12 17.8327Z"
                fill="#0F47AF" />
            <path
                d="M12.0029 8.23269L11.8342 8.80789L12.5298 11.1807H11.6022L11.498 11.5362H14.4722L14.9137 11.1807H12.867L12.0026 8.23242L12.0029 8.23269Z"
                fill="#FCDD09" />
            <path
                d="M13.0454 10.9184L14.2712 9.04883L13.0454 10.9184Z"
                fill="black" />
            <path
                d="M14.2053 8.99739L12.9795 10.8672L13.1093 10.9717L14.3352 9.10193L14.2053 8.99739Z"
                fill="#FCDD09" />
            <path
                d="M15.6628 11.1809H15.1171L13.2958 12.6473L13.0092 11.6697H12.6719L13.5911 14.8044L14.0326 15.1599L13.4002 13.0028L15.6633 11.1807L15.6628 11.1809Z"
                fill="#FCDD09" />
            <path
                d="M13.6807 13.1035L15.6639 13.8176L13.6807 13.1035Z"
                fill="black" />
            <path
                d="M13.7019 13.0193L13.6523 13.1885L15.6358 13.9027L15.6854 13.7335L13.7019 13.0193Z"
                fill="#FCDD09" />
            <path
                d="M14.2609 15.9515L14.0922 15.3763L12.2709 13.9099L13.0214 13.3057L12.9172 12.9502L10.511 14.8875L10.3423 15.4627L11.998 14.1297L14.2611 15.9518L14.2609 15.9515Z"
                fill="#FCDD09" />
            <path
                d="M12.077 14.4551H11.9165V16.7663H12.077V14.4551Z"
                fill="#FCDD09" />
            <path
                d="M9.73575 15.951L10.1773 15.5955L10.8729 13.2227L11.6235 13.827L11.8963 13.6073L9.49007 11.6699H8.94434L10.6001 13.003L9.73575 15.9513V15.951Z"
                fill="#FCDD09" />
            <path
                d="M10.325 13.1035L8.3418 13.8176L10.325 13.1035Z"
                fill="black" />
            <path
                d="M10.2969 13.0202L8.31348 13.7344L8.36307 13.9035L10.3465 13.1893L10.2969 13.0202Z"
                fill="#FCDD09" />
            <path
                d="M8.33789 11.1815L8.77944 11.5369H11.0307L10.7441 12.5145L11.017 12.7343L11.9362 9.59961L11.7675 9.02441L11.1352 11.1815H8.33789Z"
                fill="#FCDD09" />
            <path
                d="M10.966 10.9184L9.74023 9.04883L10.966 10.9184Z"
                fill="black" />
            <path
                d="M9.80416 8.99604L9.67432 9.10059L10.9001 10.9704L11.03 10.8658L9.80416 8.99604Z"
                fill="#FCDD09" />
        </svg>
    `),d=l("ethiopia_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_129583)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-12 0.5H36V24.5H-12V0.5Z"
                    fill="#DA121A" />
                <path
                    d="M-12 0.5H36V16.5H-12V0.5Z"
                    fill="#FCDD09" />
                <path
                    d="M-12 0.5H36V8.5H-12V0.5Z"
                    fill="#078930" />
                <path
                    d="M12 20.5C16.4183 20.5 20 16.9183 20 12.5C20 8.08172 16.4183 4.5 12 4.5C7.58172 4.5 4 8.08172 4 12.5C4 16.9183 7.58172 20.5 12 20.5Z"
                    fill="#0F47AF" />
                <path
                    d="M11.9994 6.10001L11.719 6.96281L12.8754 10.522H11.3334L11.1602 11.0552H16.1042L16.8382 10.522H13.4358L11.999 6.09961L11.9994 6.10001Z"
                    fill="#FCDD09" />
                <path
                    d="M13.7227 10.1276L15.7603 7.32324L13.7227 10.1276Z"
                    fill="black" />
                <path
                    d="M15.6549 7.24608L13.6172 10.0508L13.833 10.2076L15.8708 7.4029L15.6549 7.24608Z"
                    fill="#FCDD09" />
                <path
                    d="M18.0853 10.5229H17.1781L14.1505 12.7225L13.6741 11.2561H13.1133L14.6413 15.9581L15.3753 16.4913L14.3241 13.2557L18.0861 10.5225L18.0853 10.5229Z"
                    fill="#FCDD09" />
                <path
                    d="M14.7891 13.4072L18.0859 14.4784L14.7891 13.4072Z"
                    fill="black" />
                <path
                    d="M14.8285 13.2804L14.7461 13.5342L18.0432 14.6055L18.1257 14.3517L14.8285 13.2804Z"
                    fill="#FCDD09" />
                <path
                    d="M15.7601 17.6778L15.4797 16.815L12.4521 14.6154L13.6997 13.709L13.5265 13.1758L9.52649 16.0818L9.24609 16.9446L11.9985 14.945L15.7605 17.6782L15.7601 17.6778Z"
                    fill="#FCDD09" />
                <path
                    d="M12.1301 15.4336H11.8633V18.9004H12.1301V15.4336Z"
                    fill="#FCDD09" />
                <path
                    d="M8.24138 17.6775L8.97538 17.1443L10.1318 13.5851L11.3794 14.4915L11.833 14.1619L7.83298 11.2559H6.92578L9.67818 13.2555L8.24138 17.6779V17.6775Z"
                    fill="#FCDD09" />
                <path
                    d="M9.21477 13.4062L5.91797 14.4774L9.21477 13.4062Z"
                    fill="black" />
                <path
                    d="M9.17212 13.2812L5.875 14.3525L5.95745 14.6063L9.25457 13.535L9.17212 13.2812Z"
                    fill="#FCDD09" />
                <path
                    d="M5.91406 10.5227L6.64806 11.0559H10.3905L9.91406 12.5223L10.3677 12.8519L11.8957 8.14991L11.6153 7.28711L10.5641 10.5227H5.91406Z"
                    fill="#FCDD09" />
                <path
                    d="M10.2798 10.1276L8.24219 7.32324L10.2798 10.1276Z"
                    fill="black" />
                <path
                    d="M8.34866 7.24455L8.13281 7.40137L10.1705 10.2061L10.3864 10.0492L8.34866 7.24455Z"
                    fill="#FCDD09" />
            </g>
            <defs>
                <clipPath id="clip0_19477_129583">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Ethiopia,d as EthiopiaRounded};
